export default "__VITE_ASSET__CN34gve___"